import '@qnpm/react-native-ext';
import React from 'react';
import { Text } from 'react-native';
import Icon from '../../../components/Icon';
import isLowAdr from '../../../constant/isLowAdr';
// import { Url } from './urlConfig';
import { Colors } from '@qnpm/q-theme';

const { scenes:{ baseColor } } = Colors;

export default {
    isShow: true,
    statusBarBackgroundColor: isLowAdr ? 'black' : 'transparent',
    activeOpacity: 0.8,
    backgroundColor: 'transparent',
    buttonWidth: 80,
    color: 'black',
    title: (
        <Text
            style={{
                fontSize: 18,
                color: baseColor.text1
            }}
        >
            手机查单
        </Text>
    ),
    leftButtonText: (
        <Text style={{ color: baseColor.text2 }}>
            <Icon code="&#xf07d;" size={20} />
        </Text>
    ),
    leftButtonPressEvent() {
        Ext.back();
    }
};
